
export class Scene2 extends Phaser.Scene {

  constructor() {
    super({
        key: "Scene2"
    });
  }

    preload(): void {

        this.load.image("metal", require("/src/assets/phaser-assets/textures/metal.png"));

  }

    create(): void {

        let im = this.add.image(200, 250, "metal");
        im.setOrigin(0);
        im.setDisplaySize(400, 400);


  }

  update(): void {
   
  }

}



// WEBPACK FOOTER //
// ./src/games/demos/phaserMultiSceneDemo/scenes/scene2.ts